import React from 'react';
import { Alert, Button } from 'antd';
import { EyeOutlined, LinkOutlined } from '@ant-design/icons';

const AuctionTypeAlert = ({ isPrivate, onImageModalClick }) => {
    return isPrivate ? (
        <Alert
            message={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Private Auction Instructions</span>
                    <Button 
                        type="link" 
                        onClick={onImageModalClick}
                        icon={<EyeOutlined />}
                    >
                        View Instructions
                    </Button>
                </div>
            }
            description={
                <div>
                    <p>For private auctions, you'll need to add participants after creating the auction. Here's what you need to do:</p>
                    <ol>
                        <li>Create the auction first</li>
                        <li>Wait for admin approval (auction status becomes active)</li>
                        <li>Before the auction starts, add participants from My Auctions → Actions menu in any of these ways:
                            <ul>
                                <li>Send direct email invitations to specific users</li>
                                <li>Generate one-time use direct links that you can share with potential participants</li>
                                <li>Upload Bulk Users via CSV (creates approved accounts with temporary passwords, or adds existing users as accepted participants)</li>
                            </ul>
                        </li>
                        <li>Only invited or accepted participants will be able to bid in this auction</li>
                        <li>New users created via CSV must change their temporary password on first login</li>
                    </ol>
                </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: '24px' }}
        />
    ) : (
        <Alert
            message="Public Auction Information"
            description={
                <div>
                    <p>Public auctions are open to all registered users. Here's what you need to know:</p>
                    <ul>
                        <li>Anyone with an account can view and participate in your auction</li>
                        <li>No need to manually invite participants</li>
                    </ul>
                </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: '24px' }}
        />
    );
};

export default AuctionTypeAlert; 